var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "suggestionList",
    staticClass: "list-group shadow"
  }, _vm._l(_vm.matchedItems, function (item, id) {
    return _c('vue-typeahead-bootstrap-list-item', _vm._g({
      key: id,
      attrs: {
        "active": _vm.isListItemActive(id),
        "id": _vm.isListItemActive(id) ? "selected-option-".concat(_vm.vbtUniqueId) : false,
        "data": item.data,
        "html-text": _vm.highlight(item.text),
        "role": "option",
        "aria-selected": _vm.isListItemActive(id) ? 'true' : 'false',
        "screen-reader-text": item.screenReaderText ? item.screenReaderText : item.text,
        "disabled": _vm.isDisabledItem(item),
        "background-variant": _vm.backgroundVariant,
        "background-variant-resolver": _vm.backgroundVariantResolver,
        "text-variant": _vm.textVariant
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.handleHit(item, $event);
        }
      },
      scopedSlots: _vm._u([{
        key: "suggestion",
        fn: function fn(_ref) {
          var data = _ref.data,
            htmlText = _ref.htmlText;
          return _vm.$scopedSlots.suggestion ? [_vm._t("suggestion", null, null, {
            data: data,
            htmlText: htmlText
          })] : undefined;
        }
      }], null, true)
    }, _vm.$listeners));
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }